export default "__VITE_ASSET__DDZVDN0c__"